import React from 'react'
import { Helmet } from 'react-helmet'

import { headScripts, headNoscripts } from '../utils/head-utils'

function Head() {
  return <Helmet script={headScripts} noscript={headNoscripts}></Helmet>
}

export default Head
